// Render this from components that actually display YouTube content
// (thumbnails or embeds). Next.js App Router hoists <link> tags from any
// nested Server Component into <head>, and dedupes by href, so it's safe
// to render this from multiple sites — the browser sees only one preconnect.
//
// Previously this lived in the global app layout, but Lighthouse flagged it
// as an "Unused preconnect" on pages without videos (the homepage). Each
// preconnect costs a DNS + TCP + TLS handshake (~150-300ms on mobile),
// stealing bandwidth from preconnects to origins the page actually uses.
export default function YoutubePreconnect() {
  return <link rel="preconnect" href="https://img.youtube.com" />
}
